const colors = {
    general: {
        white: '#FFFFFF',
        black: '#000000',
        persianBlue: '#194AB9',
        blueRibbon: '#064CEC',
        malachite: '#09C91C'
    },
    text: {
        ebony: '#121A2C',
        kleinBlue: '#0036B1',
        emperor: '#4F4F4F',
        mineShaft: '#333333',
        chambray: '#354C82',
        gray: '#828282',
        salem: '#0EA41D',
        burntSienna: '#EB5757',
        mountainMeadow: '#20BE79',
        blue:'#194AB9;'
    },
    border: {
        silver: '#BDBDBD',
        poloBlue: '#93A7D3',
        salem: '#0EA41D',
        concrete: '#F2F2F2',
        burntSienna: '#EB5757',
    },
    background: {
        lochmara: '#0082C8',
        blueRomance: '#DAF9DD',
        white: '#FFFFFF',
        malibu: '#66BDFF',
        chambray: '#3b5998',
        lilyWhite: '#E9F8FF',
        cinderella: '#FEE3E3',
        kleinBlue: '#0036B1',
        danube: '#7893D0',
        salem: '#0EA41D',
        bridesmaid: '#FEEFEF',
        linkWater: '#ECF1FB'
    },
    error: {
        sunsetOrange: '#F9503D'
    }
}

export {colors};
